export const getLocaleText = (t) => ({
    /** =========================
     * FILTER TOOL PANEL
     * ========================= */
    filters: t('ag.filters'),
    filterOoo: t('ag.filterOoo'),
    applyFilter: t('ag.applyFilter'),
    resetFilter: t('ag.resetFilter'),
    clearFilter: t('ag.clearFilter'),
    cancelFilter: t('ag.cancelFilter'),
    searchOoo: t('ag.searchOoo'),
    selectAll: t('ag.selectAll'),
    selectAllSearchResults: t('ag.selectAllSearchResults'),
    addCurrentSelectionToFilter: t('ag.addCurrentSelectionToFilter'),
    noMatches: t('ag.noMatches'),

    /** =========================
     * TEXT FILTER
     * ========================= */
    equals: t('ag.equals'),
    notEqual: t('ag.notEqual'),
    contains: t('ag.contains'),
    notContains: t('ag.notContains'),
    startsWith: t('ag.startsWith'),
    endsWith: t('ag.endsWith'),
    blank: t('ag.blank'),
    notBlank: t('ag.notBlank'),

    /** =========================
     * NUMBER FILTER
     * ========================= */
    lessThan: t('ag.lessThan'),
    lessThanOrEqual: t('ag.lessThanOrEqual'),
    greaterThan: t('ag.greaterThan'),
    greaterThanOrEqual: t('ag.greaterThanOrEqual'),
    inRange: t('ag.inRange'),
    inRangeStart: t('ag.inRangeStart'),
    inRangeEnd: t('ag.inRangeEnd'),

    /** =========================
     * DATE FILTER
     * ========================= */
    dateFormatOoo: t('ag.dateFormatOoo'),
    before: t('ag.before'),
    after: t('ag.after'),

    /** =========================
     * SET FILTER
     * ========================= */
    loadingOoo: t('ag.loadingOoo'),
    blanks: t('ag.blanks'),

    /** =========================
     * ADVANCED / MULTI FILTER
     * ========================= */
    andCondition: t('ag.andCondition'),
    orCondition: t('ag.orCondition'),

    /** =========================
     * FILTER PANEL BUTTONS
     * ========================= */
    apply: t('ag.apply'),
    clear: t('ag.clear'),
    reset: t('ag.reset'),
    cancel: t('ag.cancel'),


    empty: t('ag.empty'),
    true: t('ag.true'),
    false: t('ag.false')
})
